export const getStatus = () => {
    return [{text:"New Ticket", value:"New Ticket"},
    {text:"In Progress", value:"In Progress"},
    {text:"Awaiting External", value:"Awaiting External"},
    {text:"Completed", value:"Completed"}]
}
export const getSites = () => {
    return [{text:"West Chinnock", value:"West Chinnock"}, {text:"Norton Sub Hamdon", value:"Norton Sub Hamdon"}]
}